import { render, staticRenderFns } from "./-Testimonials.vue?vue&type=template&id=0589d0db&scoped=true&"
import script from "./-Testimonials.vue?vue&type=script&lang=js&"
export * from "./-Testimonials.vue?vue&type=script&lang=js&"
import style0 from "./-Testimonials.vue?vue&type=style&index=0&id=0589d0db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589d0db",
  null
  
)

export default component.exports